import { SensorsStompService } from './../shared/services/stomp/sensors-stomp.service';
import { NgModule, Optional, SkipSelf } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { RouteReuseStrategy, RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

import { RouteReusableStrategy } from './route-reusable-strategy';
import { HttpService } from './http/http.service';
import { ApiService } from './api-service/api.service';
import { CoreFormComponent } from '@app/core/components/core-form/core-form.component';
import { SharedModule } from '@app/shared/shared.module';
import { CoreListComponent } from '@app/core/components/core-list/core-list.component';
import { TourMatMenuModule } from 'ngx-ui-tour-md-menu';
import { RxStompService } from '@app/shared/services/stomp/rx-stomp.service';
import { SensorsStompConfig } from '@app/shared/services/stomp/sensors-stomp.config.service';
import { CoreViewComponent } from './components/core-view/core-view.component';

@NgModule({
  imports: [CommonModule, HttpClientModule, TranslateModule, RouterModule, SharedModule, TourMatMenuModule],
  providers: [
    {
      provide: HttpClient,
      useClass: HttpService,
    },
    {
      provide: RouteReuseStrategy,
      useClass: RouteReusableStrategy,
    },
    SensorsStompService,
    SensorsStompConfig,
    ApiService,
  ],
  declarations: [CoreListComponent, CoreFormComponent,CoreViewComponent],
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    // Import guard
    if (parentModule) {
      throw new Error(`${parentModule} has already been loaded. Import Core module in the AppModule only.`);
    }
  }
}
